import Chip, { ChipProps } from "@mui/material/Chip";
import { useTranslation } from "react-i18next";

interface Props {
  completed?: boolean;
  size?: ChipProps["size"];
}

export const CocStatusChip = ({ completed, size = "small" }: Props) => {
  const { t: te } = useTranslation("enums");

  return (
    <Chip
      label={completed ? te("completed") : te("not_completed")}
      color={completed ? "success" : "default"}
      variant={completed ? "filled" : "outlined"}
      size={size}
      sx={{ fontWeight: 600, fontSize: "0.7rem" }}
    />
  );
};
